import React from 'react';
import { Activity, UploadCloud, TrendingUp, Search, Database, ArrowRight, LineChart } from 'lucide-react';

const Card = ({ children, className }) => <div className={`bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 ${className || ''}`}>{children}</div>;
const CardHeader = ({ children }) => <div className="p-6 pb-4 border-b border-slate-100 dark:border-slate-700/50">{children}</div>;
const CardTitle = ({ children, className }) => <h3 className={`text-lg font-semibold text-slate-900 dark:text-white ${className || ''}`}>{children}</h3>;
const CardDescription = ({ children }) => <p className="text-sm text-slate-500 mt-1">{children}</p>;
const CardContent = ({ children, className }) => <div className={`p-6 ${className || ''}`}>{children}</div>;

export default function OmniTrendRadar() {
  return (
    <div className="p-8 max-w-7xl mx-auto space-y-6">
      <div className="flex justify-between items-end mb-8">
        <div>
          <h1 className="text-3xl font-bold text-slate-900 dark:text-white flex items-center gap-3">
            <Activity className="w-8 h-8 text-blue-500" />
            全域趋势雷达 (Omni-Trend Radar)
          </h1>
          <p className="text-slate-500 mt-2">捕获外部平台真实的搜索痛点与场景情绪，注入系统作为意图核聚变的源燃料。</p>
        </div>
        <div className="flex gap-3">
          <button className="px-4 py-2 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-lg shadow-md hover:from-blue-700 hover:to-cyan-600 flex items-center gap-2">
             <UploadCloud className="w-4 h-4" /> 导入最新市场信号
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <Card>
          <CardHeader>
             <CardTitle className="flex items-center gap-2"><Search className="w-5 h-5 text-blue-600" /> 百度观星盘 - 核心痛点</CardTitle>
             <CardDescription>上次更新: 2小时前 | 捕捉 240 个高优搜索词</CardDescription>
          </CardHeader>
          <CardContent>
             <div className="space-y-4">
               {[
                 { word: "梵克雅宝项链保值吗", vol: "85,230" },
                 { word: "四叶草红玉髓真假鉴定", vol: "42,100" },
                 { word: "梵克雅宝哪里买便宜", vol: "38,500" }
               ].map((item, idx) => (
                 <div key={idx} className="flex justify-between items-center p-3 bg-slate-50 dark:bg-slate-900/50 rounded-lg">
                    <span className="text-slate-700 dark:text-slate-300 font-medium">{item.word}</span>
                    <span className="text-blue-600 dark:text-blue-400 text-sm font-mono">{item.vol} 热度</span>
                 </div>
               ))}
               <button className="w-full py-2 text-sm text-blue-600 hover:bg-blue-50 dark:hover:bg-slate-800 rounded transition-colors">查看全部 240 个信号</button>
             </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
             <CardTitle className="flex items-center gap-2"><TrendingUp className="w-5 h-5 text-rose-600" /> 小红书聚光 - 情绪与场景</CardTitle>
             <CardDescription>上次更新: 2小时前 | 捕捉 150 个热门场景词</CardDescription>
          </CardHeader>
          <CardContent>
             <div className="space-y-4">
               {[
                 { word: "恋爱三周年礼物", vol: "120,400" },
                 { word: "老钱风穿搭首饰", vol: "95,000" },
                 { word: "送给30岁自己的礼物", vol: "88,200" }
               ].map((item, idx) => (
                 <div key={idx} className="flex justify-between items-center p-3 bg-slate-50 dark:bg-slate-900/50 rounded-lg">
                    <span className="text-slate-700 dark:text-slate-300 font-medium">{item.word}</span>
                    <span className="text-rose-600 dark:text-rose-400 text-sm font-mono">{item.vol} 热度</span>
                 </div>
               ))}
               <button className="w-full py-2 text-sm text-rose-600 hover:bg-rose-50 dark:hover:bg-slate-800 rounded transition-colors">查看全部 150 个场景</button>
             </div>
          </CardContent>
        </Card>
      </div>

      <Card className="bg-gradient-to-r from-slate-900 to-blue-900 text-white border-none shadow-xl">
         <CardContent className="p-8 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
               <h3 className="text-xl font-bold mb-2 flex items-center gap-2"><Database className="w-6 h-6 text-cyan-400" /> 信号就绪，等待核聚变</h3>
               <p className="text-slate-300 text-sm max-w-lg">系统已准备好将捕获的市场信号，与您设定的【业务维度】和【受众人设】进行模型杂交，生成 AI 意图作战网格。</p>
            </div>
            <button className="px-6 py-3 bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-bold rounded-lg shadow-lg flex items-center gap-2 transition-all hover:scale-105">
               启动意图杂交引擎 <ArrowRight className="w-5 h-5" />
            </button>
         </CardContent>
      </Card>
    </div>
  );
}
